// =========================================================
// * Vuetify Material Dashboard PRO - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import store from '@/store/index'
import './plugins/base'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import '@/styles/style.scss'
// Plugins
import plugins from '@/utils/plugins/index'
// i18n
import i18n from './i18n'
// Router — point d'entrée unifié
import router from '@/router'
// MSAL
import { EventType } from '@azure/msal-browser'
import msalPlugin from './plugins/msalPlugin'
import { msalInstance } from './config/msal'
import logger from '@/utils/logger'

// MSAL v3: Must call initialize() before any other MSAL API
// Then handleRedirectPromise() must be called ONCE at app startup
const initializeMsal = async () => {
  try {
    // MSAL v3 requires explicit initialization
    await msalInstance.initialize()

    // Handle redirect response (if returning from Azure AD login)
    const response = await msalInstance.handleRedirectPromise()
    if (response) {
      // User just logged in via redirect, set the account
      msalInstance.setActiveAccount(response.account)
    } else {
      // No redirect response, check for existing accounts
      const accounts = msalInstance.getAllAccounts()
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0])
      }
    }
  } catch (error) {
    logger.error('MSAL initialization error:', error)
  }
}

// Event callback for login success
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload
    const account = payload.account
    msalInstance.setActiveAccount(account)
  }
})

// Authentification est 'msal'
Vue.use(msalPlugin, msalInstance)

Vue.config.productionTip = false
// $company, $fournisseur, $env → migré vers useAppConfig composable

// Plugins
Vue.use(plugins)

// Initialize MSAL first, then start Vue app
initializeMsal().then(() => {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
  }).$mount('#app')
})
